import React, { useEffect, useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { ServiceHistoryButton } from "@/components/ServiceHistoryButton";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Boxes, Gift, Zap, ReceiptText } from "lucide-react";

const ICON = { gift: Gift, ricarica: Zap, servizio: ReceiptText };

export default function OpenApiServices() {
  const [services, setServices] = useState([]);
  const [mode, setMode] = useState("mock");
  const [buying, setBuying] = useState(null);

  const loadServices = () => api.get("/openapi/services").then((r) => { setServices(r.data.services || []); setMode(r.data.mode); }).catch(() => {});
  useEffect(() => { loadServices(); }, []);

  const buy = async (p) => {
    setBuying(p.id);
    try {
      const { data } = await api.post("/wallet/pay", { product_id: p.id, quantity: 1 });
      toast.success(`Venduto! Scalati ${euro(data.amount)} dal Plafond servizi.` + (data.gift_code ? ` Codice: ${data.gift_code}` : ""));
      loadServices();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore vendita");
    } finally { setBuying(null); }
  };

  return (
    <div className="space-y-6" data-testid="openapi-services-page">
      <ServiceHistoryButton service="servizi" />
      <div className="flex items-center gap-3">
        <div>
          <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Servizi pubblici</p>
          <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Servizi &amp; Pratiche</h1>
        </div>
        <Badge variant="outline" className="uppercase ml-auto" data-testid="openapi-mode-badge">{mode}</Badge>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((p) => {
          const Icon = ICON[p.category] || Boxes;
          return (
            <Card key={p.id} className="overflow-hidden glow-border flex flex-col" data-testid={`openapi-card-${p.openapi_service_id || p.id}`}>
              <div className="h-32 bg-secondary/50 relative flex items-center justify-center">
                {p.image_url ? <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" /> : <Icon className="w-12 h-12 text-primary/60" />}
                <Badge className="absolute top-3 left-3 capitalize bg-background/80 text-foreground border border-border">{p.category}</Badge>
              </div>
              <div className="p-5 flex flex-col flex-1">
                {p.operator && <Badge variant="outline" className="text-xs w-fit">{p.operator}</Badge>}
                <h3 className="font-head font-semibold text-lg mt-2">{p.name}</h3>
                <p className="text-sm text-muted-foreground mt-1 flex-1">{p.description}</p>
                <div className="flex items-center justify-between mt-3">
                  <span className="font-head text-2xl font-bold">{euro(p.price)}</span>
                  <Button size="sm" disabled={buying === p.id} onClick={() => buy(p)} data-testid={`openapi-buy-${p.id}`}>{buying === p.id ? "Attendi…" : "Vendi (Plafond)"}</Button>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
      {services.length === 0 && <p className="text-muted-foreground">Nessun servizio disponibile.</p>}
    </div>
  );
}
